import React from 'react';
import { TabHeaders } from '../constants';
import Newspaper from './Newspaper';
import Magazine from './Magazine';
import TvRadio from './TvRadio';
import Online from './Online';
export function getTabList(activeTabIndex) {
  return [{
    header: TabHeaders.MAGAZINE,
    panel: activeTabIndex === 0 ? /*#__PURE__*/React.createElement(Magazine, null) : /*#__PURE__*/React.createElement(React.Fragment, null)
  }, {
    header: TabHeaders.NEWSPAPER,
    panel: activeTabIndex === 1 ? /*#__PURE__*/React.createElement(Newspaper, null) : /*#__PURE__*/React.createElement(React.Fragment, null)
  }, {
    header: TabHeaders.ONLINE,
    panel: activeTabIndex === 2 ? /*#__PURE__*/React.createElement(Online, null) : /*#__PURE__*/React.createElement(React.Fragment, null)
  }, {
    header: TabHeaders.TV_RADIO,
    panel: activeTabIndex === 3 ? /*#__PURE__*/React.createElement(TvRadio, null) : /*#__PURE__*/React.createElement(React.Fragment, null)
  }];
}